import { Banner, Text } from "@jsq/ds/core";
import { generateGpMainUrl } from "~/utils/url";
import { BannerButton } from "../styles_vanilla.css";

type Props = {
  arenaName: string;
  entityName: string;
  arenaSubdomain: string;
  entityId: number;
  entityTransferEnabled: boolean;
  transferBeforeStartDateError: boolean;
  hasMixedFunds: boolean;
};

const NO_ENTITY_SETTINGS_DESCRIPTION =
  "Go to the entity and turn off transfer accounting under metrics settings to sync transfers.";
const CannotSyncBanner = (props: Props) => {
  const ownershipEventErrorMsg = () => {
    return props.transferBeforeStartDateError
      ? "At least one of the transfer events has a GL date prior to the sync date range. Update the sync date range to include the unsynced transfers."
      : `At least one of the transfer events within the sync date range was not recorded in ${props.arenaName}'s workspace. Record the relevant transfer event to sync.`;
  };

  const getBannerDescription = () => {
    if (props.entityTransferEnabled) {
      return NO_ENTITY_SETTINGS_DESCRIPTION;
    }
    if (props.transferBeforeStartDateError) {
      return ownershipEventErrorMsg();
    }
    if (props.hasMixedFunds) {
      return `The selected sync date range includes outstanding transfers for ${props.entityName} with a mix of historical capital calls and standalone contributions. Please review transactions in ${props.arenaName}'s workspace.`;
    }
  };
  const bannerDescription = <Text style={{ maxWidth: "700px" }}>{getBannerDescription()}</Text>;
  const gpMainUrl = generateGpMainUrl(props.arenaSubdomain);
  return (
    <Banner
      variant="danger"
      title="Unable to sync transfers"
      description={bannerDescription}
      buttonProps={
        props.entityTransferEnabled ||
        !props.transferBeforeStartDateError ||
        props.hasMixedFunds
          ? {
              children: "Go to entity",
              variant: "neutral",
              className: BannerButton,
              onClick: () => {
                const gpUrl = `${gpMainUrl}/account/${props.entityId}`;
                window.open(gpUrl, "_blank");
              },
              icon: "external-link",
              iconPosition: "right",
            }
          : undefined
      }
    />
  );
};

export default CannotSyncBanner;
